import { render, staticRenderFns } from "./StockHome.vue?vue&type=template&id=d20ed062&scoped=true&"
import script from "./StockHome.vue?vue&type=script&lang=js&"
export * from "./StockHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ed062",
  null
  
)

export default component.exports